<template>
  <div :class="['row', alignSelfComp, justifyContentComp]">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'content-row',
    props: {
      alignSelf: {
        type: String,
        default: 'center'
      },
      justifyContent: {
        type: String,
        default: 'center'
      }
    },
    computed: {
      alignSelfComp() {
        return `align-self-${this.alignSelf}`
      },
      justifyContentComp() {
        return `justify-content-${this.justifyContent}`
      }
    }
  }
</script>